export const GrispiEvents = {
    CALL_EVENT_STATUS_SET: 'grispi.call.event.statusSet',
    CALL_EVENT_INCOMING: 'grispi.call.event.incoming',
    CALL_EVENT_STARTED: 'grispi.call.event.started',
    CALL_EVENT_DIALING: 'grispi.call.event.dialing',
    CALL_EVENT_ENDED: 'grispi.call.event.ended',
    REQUEST_CURRENT_TICKET: 'grispi.plugin.request.currentTicket',
    RESPONSE_CURRENT_TICKET: 'grispi.plugin.response.currentTicket',
    REQUEST_INIT: 'grispi.plugin.request.init',
    RESPONSE_INIT: 'grispi.plugin.response.init',
    ACTIVE_TICKET_CHANGED: 'grispi.plugin.fn.activeTicketChanged',
    // Internal events
    SHOW_PLUGIN_EVENT: 'grispi.main.plugin.show', // Dispatched from this window
    MESSAGE_TO_PLUGIN: 'grispi.main.plugin.sendMessage' // Dispatched from this window
};

export const GrispiActions = {};
